import React, { Component } from 'react';
import './CreateModal.scss';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateCurrentTabStatus, updateBotValue, successGenericDataGet } from '../../Redux/Actions/uiActions';
import Button from '../../Elements/Atoms/Button';
import clearIcon from '../../../assets/icons/ic_close_light_grey.png';
import ImgTag from '../../Elements/Atoms/ImgTag';

class CreateModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isGeneric: false,
            currentData: {
                title: '',
                Desc: ''
            },
            inputRadioData: ['', ''],
            tempkey: new Date().getTime(),
            radiokey: new Date().getTime()
        }
    }

    componentDidMount() {
        const firstParam = this.props.location.pathname.split('/')[1];
        if(firstParam === 'genericconfig' && !this.state.isGeneric) {
            this.setState({isGeneric: true})
        } else if(this.state.isGeneric){
            this.setState({isGeneric: false})
        }
    }

    getReadableName = (actualName) => {
        if(actualName) {
            const readableName = actualName.replace(/-|_|\//g, ' ');
            return readableName;
        }
    }

    checkValidName = (val) => (/^[a-zA-Z][a-zA-Z0-9 -_]+$/.test(val));

    updateOnLocation = (dataObj, dataKey, parentArray) => {
        // console.log('reached Here', dataObj, dataKey, parentArray);
        let currentData = this.state.isGeneric ? this.props.genericBotData : this.props.editableBotData;
        if(parentArray.length) {
            let tempArr = [];
            parentArray.forEach((elm, i) => {
                if(elm.indexOf('Object ') > -1) {
                    let searchedElem = elm.slice(7, 8);
                    searchedElem = parseInt(searchedElem) - 1;
                    tempArr.push('VALUE');
                    tempArr.push(searchedElem);
                } else {
                    tempArr.push(elm);
                }
            });
            parentArray = tempArr;
        }
        if(parentArray[0] === 'OPTIONS') {
            parentArray.push('ANALYTICS_TRACK');
        }
        if(parentArray.length === 1) {
            if(parentArray[0] === 'SETTINGS' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS' || parentArray[0] === 'CHATBOT') {
                currentData[parentArray[0]][dataKey] = dataObj;
            } else {
                currentData.UI_OPTIONS[parentArray[0]][dataKey] = dataObj;
            }
        } else if(parentArray.length === 2) {
            if(parentArray[0] === 'SETTINGS' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS' || parentArray[0] === 'CHATBOT') {
                currentData[parentArray[0]][parentArray[1]][dataKey] = dataObj;
            } else {
                currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][dataKey] = dataObj;
            }
        } else if(parentArray.length === 3) {
            if(parentArray[0] === 'SETTINGS' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS' || parentArray[0] === 'CHATBOT') {
                currentData[parentArray[0]][parentArray[1]][parentArray[2]][dataKey] = dataObj;
            } else {
                currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][dataKey] = dataObj;
            }
        } else if(parentArray.length === 4) {
            if(parentArray[0] === 'SETTINGS' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS' || parentArray[0] === 'CHATBOT') {
                currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][dataKey] = dataObj;
            } else {
                currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][dataKey] = dataObj;
            }
        } else if(parentArray.length === 5) {
            if(parentArray[0] === 'SETTINGS' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS' || parentArray[0] === 'CHATBOT') {
                currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][dataKey] = dataObj;
            } else {
                currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][dataKey] = dataObj;
            }
        } else if(parentArray.length === 6) {
            if(parentArray[0] === 'SETTINGS' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS' || parentArray[0] === 'CHATBOT') {
                currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][dataKey] = dataObj;
            } else {
                currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][dataKey] = dataObj;
            }
        } else if(parentArray.length === 7) {
            if(parentArray[0] === 'SETTINGS' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS' || parentArray[0] === 'CHATBOT') {
                currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][dataKey] = dataObj;
            } else {
                currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][dataKey] = dataObj;
            }
        } else if(parentArray.length === 8) {
            if(parentArray[0] === 'SETTINGS' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS' || parentArray[0] === 'CHATBOT') {
                currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][dataKey] = dataObj;
            } else {
                currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][dataKey] = dataObj;
            }
        } else if(parentArray.length === 9) {
            if(parentArray[0] === 'SETTINGS' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS' || parentArray[0] === 'CHATBOT') {
                currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]][dataKey] = dataObj;
            } else {
                currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]][dataKey] = dataObj;
            }
        } else if(parentArray.length === 10) {
            if(parentArray[0] === 'SETTINGS' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS' || parentArray[0] === 'CHATBOT') {
                currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]][parentArray[9]][dataKey] = dataObj;
            } else {
                currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]][parentArray[9]][dataKey] = dataObj;
            }
        } else if(parentArray.length === 11) {
            if(parentArray[0] === 'SETTINGS' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS' || parentArray[0] === 'CHATBOT') {
                currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]][parentArray[9]][parentArray[10]][dataKey] = dataObj;
            } else {
                currentData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]][parentArray[9]][parentArray[10]][dataKey] = dataObj;
            }
        }
        // console.log('2222222222222222',currentData, dataObj, dataKey, parentArray);
        return currentData;
    }

    removeCurrentField = (e, index, type) => {
        let tempArr = this.state.inputRadioData;
        const newArr = tempArr.filter((e, i) => i !== index);
        this.setState({inputRadioData: newArr, radiokey : new Date().getTime()})
    };

    loadRemoveIcon = (index, type) => {
        return (
            <span className = 'array-input-clear-iocn-wrapper' onClick = {
                (e) => {
                    this.removeCurrentField(e, index, type);
                }
            }>
                <ImgTag
                    alt = 'Remove Field'
                    className = 'array-input-clear-iocn'
                    src = {clearIcon}
                />
            </span>
        );
    }

    handleChange(index, e){
        let tempArr = this.state.inputRadioData;
        tempArr[index] = e.target.value.trim();
        this.setState({inputRadioData: tempArr});
    }

    addRadioInputs = () => {
        return (
            <>
                {this.state.inputRadioData.map((elm, i) => {
                    return (
                        <div className = "menu-input-block field-size-lg multiple" key = {i + this.state.radiokey}>
                            <div className = "menu-label">
                                <label className = "menu-title">Radio Button {i+1} Title</label>
                            </div>
                            <div className = "menu-input-area">
                                <div className = "character-input-box field-size-md">
                                    <input className = "form-control character-input" type="text" placeholder="Add here..." autoComplete="off" defaultValue={elm} onChange={this.handleChange.bind(this, i)}/>
                                </div>
                            </div>
                            {this.state.inputRadioData.length > 2 ? this.loadRemoveIcon(i, 'radiotoggle') : null}
                        </div>
                    );
                })}
            </>
        )
    }

    addMenuType = (type) => {
        let currTitle = this.state.currentData.Title;
        let currDesc = this.state.currentData.Desc;
        let currRadioArr = this.state.inputRadioData;
        let currVal = undefined, currExtra = undefined, currKey = undefined, currUnit = '';
        let modalType = undefined;
        let defaultData = this.props.createMenuData;
        let currentType = '';
        if(defaultData) {
            currTitle = defaultData.parentArray[defaultData.parentArray.length - 1];
            currDesc = defaultData.createMenuData.ELEM_DESC;
            currVal = defaultData.createMenuData.VALUE;
            currExtra = defaultData.createMenuData;
            currUnit = defaultData.createMenuData.UNIT;
            currRadioArr = Object.keys(defaultData.parentArray).splice(2,Object.keys(defaultData.parentArray).length);
            modalType = defaultData.modalType;
            currentType = defaultData.createMenuData.ELEM_TYPE;
        }
        let popupHeader = '', buttonText = '';
        // console.log(modalType, this.props.modalType, modalType === 'Clone',currExtra);
        if(modalType && modalType === 'Clone') {
            currTitle = currTitle + '_COPY';
        }
        buttonText = modalType && modalType === 'Clone' ? 'Clone' :
                                  modalType === 'Update' ? 'Update' :
                                  'Create';
        switch(type) {
            case 'switchtoggle':
                popupHeader = modalType && modalType === 'Clone' ? this.getReadableName('Clone Switch Toggle') :
                                           modalType === 'Update' ? this.getReadableName('Update Switch Toggle') :
                                           this.getReadableName('Add Switch Toggle');
                return(
                    <div className = 'create-menu-box' key = {this.state.tempkey}>
                        <h3 className = 'tab-header'>{popupHeader}</h3>
                        <div className = 'menu-body'>
                            <div className = 'menu-input-wrapper'>
                                <div className = "menu-input-block field-size-lg" key = {-2}>
                                    <div className = "menu-label">
                                        <label className = "menu-title">Title</label>
                                    </div>
                                    <div className = "menu-input-area">
                                        <div className = "character-input-box field-size-md">
                                            <input className = "form-control character-input" type="text" placeholder="Add here..." autoComplete="off" defaultValue={currTitle} ref = {Title => this.Title = Title}/>
                                        </div>
                                    </div>
                                </div>
                                <div className = "menu-input-block field-size-lg" key = {-1}>
                                    <div className = "menu-label">
                                        <label className = "menu-title">Description</label>
                                    </div>
                                    <div className = "menu-input-area">
                                        <div className = "character-input-box field-size-md">
                                            <input className = "form-control character-input" type="text" placeholder="Add here..." autoComplete="off" defaultValue={currDesc} ref = {Desc => this.Desc = Desc}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className = 'menu-footer'>
                            <div className = 'config-input-tabs-buttons'>
                                <Button
                                    className = 'config-input-tabs-button theme-button'
                                    value = {buttonText}
                                    buttonOnClick = {(e) => {
                                        let tempObj = {},
                                            currentTitile = this.Title.value.trim(),
                                            currentDesc = this.Desc.value.trim();

                                        if(currentTitile === '') {
                                            alert(`This field can't be empty`);
                                            return;
                                        }
                                        if(!this.checkValidName(currentTitile)) {
                                            alert(`This is not a valid title`);
                                            return;
                                        }
                                        currentTitile = currentTitile.toLocaleUpperCase().replace(/ /g, '_');
                                        tempObj = {
                                            "ELEM_TYPE": "switch-toggle",
                                            "ELEM_DESC": currentDesc !== "" ? currentDesc : "NA",
                                            "VALUE": false
                                        }
                                        if(currVal) {
                                            tempObj["VALUE"] = currVal;
                                        }
                                        this.setState({currentData : {Title : currentTitile, Desc: currentDesc}, tempkey : new Date().getTime()});
                                        // this.updateOnLocation(tempObj, currentTitile, this.props.parentArray);
                                        this.state.isGeneric ?
                                            this.props.successGenericDataGet(this.updateOnLocation(tempObj, currentTitile, this.props.parentArray)) :
                                            this.props.updateBotValue(this.updateOnLocation(tempObj, currentTitile, this.props.parentArray));

                                        this.props.updateCurrentSelectedMenu('');
                                        this.setState({currentData: { title: '', Desc: '' }});
                                    }}
                                />
                                <Button
                                    className = 'config-input-tabs-button grey-button'
                                    value = 'Cancel'
                                    buttonOnClick = {(e) => {
                                        this.props.updateCurrentSelectedMenu('');
                                        this.setState({currentData: { title: '', Desc: '' }});
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                );

            case 'radiotoggle':
                popupHeader = modalType && modalType === 'Clone' ? this.getReadableName('Clone Radio Toggle') :
                                           modalType === 'Update' ? this.getReadableName('Update Radio Toggle') :
                                           this.getReadableName('Add Radio Toggle');
                return(
                    <div className = 'create-menu-box' key = {this.state.tempkey}>
                        <h3 className = 'tab-header'>{popupHeader}</h3>
                        <div className = 'menu-body'>
                            <div className = 'menu-input-wrapper'>
                                <div className = "menu-input-block field-size-lg multiple" key = {-2}>
                                    <div className = "menu-label">
                                        <label className = "menu-title">Title</label>
                                    </div>
                                    <div className = "menu-input-area">
                                        <div className = "character-input-box field-size-md">
                                            <input className = "form-control character-input" type="text" placeholder="Add here..." autoComplete="off" defaultValue={currTitle} ref = {Title => this.Title = Title}/>
                                        </div>
                                    </div>
                                </div>
                                <div className = "menu-input-block field-size-lg multiple" key = {-1}>
                                    <div className = "menu-label">
                                        <label className = "menu-title">Description</label>
                                    </div>
                                    <div className = "menu-input-area">
                                        <div className = "character-input-box field-size-md">
                                            <input className = "form-control character-input" type="text" placeholder="Add here..." autoComplete="off" defaultValue={currDesc} ref = {Desc => this.Desc = Desc}/>
                                        </div>
                                    </div>
                                </div>
                                {this.addRadioInputs()}
                                <Button
                                    className = 'border-button'
                                    value = 'Add Radio Buttons'
                                    buttonOnClick = {(e) => {
                                        e.stopPropagation();
                                        const tempArr = currRadioArr;
                                        tempArr.push('')
                                        this.setState({inputRadioData: tempArr});
                                    }}
                                />
                            </div>
                        </div>
                        <div className = 'menu-footer'>
                            <div className = 'config-input-tabs-buttons'>
                                <Button
                                    className = 'config-input-tabs-button theme-button'
                                    value = {buttonText}
                                    buttonOnClick = {(e) => {
                                        let tempObj = {},
                                            currentTitile = this.Title.value.trim(),
                                            currentDesc = this.Desc.value.trim();
 
                                        let isElmEmpty = false, isSameEntry = false, isNotValid = false;

                                        tempObj = {
                                            "ELEM_TYPE": "radio-toggle",
                                            "ELEM_DESC": currentDesc !== "" ? currentDesc : "NA"
                                        }
                                        currRadioArr.every((elm, i) => {
                                            elm = elm.trim();
                                            if(elm === '') {
                                                isElmEmpty = true;
                                                return false
                                            }
                                            if(!this.checkValidName(elm)) {
                                                isNotValid = true;
                                            }
                                            var counts = {};
                                            currRadioArr.forEach(function(x) { counts[x] = (counts[x] || 0)+1; });
                                            if(counts[elm] > 1) {
                                                isSameEntry = true;
                                                return false
                                            }
                                            tempObj[elm] = false;
                                            return true;
                                        })
                                        if(currentTitile === '' || isElmEmpty) {
                                            alert(`The field can't be empty`);
                                            return;
                                        }
                                        if(!this.checkValidName(currentTitile) || isNotValid) {
                                            alert(`This is not a valid title`);
                                            return;
                                        }

                                        if(isSameEntry) {
                                            alert(`The field can't have same value`);
                                            return;
                                        }
                                        if(currVal) {
                                            tempObj = {...tempObj, ...currVal}
                                        }
                                        this.setState({currentData : {Title : currentTitile, Desc: currentDesc}, tempkey : new Date().getTime()});
                                        currentTitile = currentTitile.toLocaleUpperCase().replace(/ /g, '_');
                                        // console.log(tempObj, this.state.inputRadioData);
                                        // this.updateOnLocation(tempObj, currentTitile, this.props.parentArray);
                                        this.state.isGeneric ?
                                            this.props.successGenericDataGet(this.updateOnLocation(tempObj, currentTitile, this.props.parentArray)) :
                                            this.props.updateBotValue(this.updateOnLocation(tempObj, currentTitile, this.props.parentArray));
                                        this.props.updateCurrentSelectedMenu('');
                                        this.setState({currentData: { title: '', Desc: '' },inputRadioData: ['', '']});
                                    }}
                                />
                                <Button
                                    className = 'config-input-tabs-button grey-button'
                                    value = 'Cancel'
                                    buttonOnClick = {(e) => {
                                        this.props.updateCurrentSelectedMenu('');
                                        this.setState({currentData: { title: '', Desc: '' },inputRadioData: ['', '']});
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                );

            case 'textfield':
                popupHeader = modalType && modalType === 'Clone' ? this.getReadableName('Clone Text Field') :
                                           modalType === 'Update' ? this.getReadableName('Update Text Field') :
                                           this.getReadableName('Add Text Field');
                return(
                    <div className = 'create-menu-box' key = {this.state.tempkey}>
                        <h3 className = 'tab-header'>{popupHeader}</h3>
                        <div className = 'menu-body'>
                            <div className = 'menu-input-wrapper'>
                                <div className = "menu-input-block field-size-lg" key = {-2}>
                                    <div className = "menu-label">
                                        <label className = "menu-title">Title</label>
                                    </div>
                                    <div className = "menu-input-area">
                                        <div className = "character-input-box field-size-md">
                                            <input className = "form-control character-input" type="text" placeholder="Add here..." autoComplete="off" defaultValue={currTitle} ref = {Title => this.Title = Title}/>
                                        </div>
                                    </div>
                                </div>
                                <div className = "menu-input-block field-size-lg" key = {-1}>
                                    <div className = "menu-label">
                                        <label className = "menu-title">Description</label>
                                    </div>
                                    <div className = "menu-input-area">
                                        <div className = "character-input-box field-size-md">
                                            <input className = "form-control character-input" type="text" placeholder="Add here..." autoComplete="off" defaultValue={currDesc} ref = {Desc => this.Desc = Desc}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className = 'menu-footer'>
                            <div className = 'config-input-tabs-buttons'>
                                <Button
                                    className = 'config-input-tabs-button theme-button'
                                    value = {buttonText}
                                    buttonOnClick = {(e) => {
                                        let tempObj = {},
                                            currentTitile = this.Title.value.trim(),
                                            currentDesc = this.Desc.value.trim();

                                        if(currentTitile === '') {
                                            alert(`This field can't be empty`);
                                            return;
                                        }
                                        if(!this.checkValidName(currentTitile)) {
                                            alert(`This is not a valid title`);
                                            return;
                                        }
                                        this.setState({currentData : {Title : currentTitile, Desc: currentDesc}, tempkey : new Date().getTime()});
                                        currentTitile = currentTitile.toLocaleUpperCase().replace(/ /g, '_');
                                        tempObj = {
                                            "ELEM_TYPE": "text-field",
                                            "ELEM_DESC": currentDesc !== "" ? currentDesc : "NA",
                                            "VALUE": ""
                                        }
                                        if(currVal) {
                                            tempObj["VALUE"] = currVal;
                                        }
                                        // this.updateOnLocation(tempObj, currentTitile, this.props.parentArray);
                                        this.state.isGeneric ?
                                            this.props.successGenericDataGet(this.updateOnLocation(tempObj, currentTitile, this.props.parentArray)) :
                                            this.props.updateBotValue(this.updateOnLocation(tempObj, currentTitile, this.props.parentArray));
                                        this.props.updateCurrentSelectedMenu('');
                                        this.setState({currentData: { title: '', Desc: '' }});
                                    }}
                                />
                                <Button
                                    className = 'config-input-tabs-button grey-button'
                                    value = 'Cancel'
                                    buttonOnClick = {(e) => {
                                        this.props.updateCurrentSelectedMenu('');
                                        this.setState({currentData: { title: '', Desc: '' }});
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                );

            case 'numberfield':
                popupHeader = modalType && modalType === 'Clone' ? this.getReadableName('Clone Number Field') :
                                           modalType === 'Update' ? this.getReadableName('Update Number Field') :
                                           this.getReadableName('Add Number Field');
                return(
                    <div className = 'create-menu-box' key = {this.state.tempkey}>
                        <h3 className = 'tab-header'>{popupHeader}</h3>
                        <div className = 'menu-body'>
                            <div className = 'menu-input-wrapper'>
                                <div className = "menu-input-block field-size-lg" key = {-2}>
                                    <div className = "menu-label">
                                        <label className = "menu-title">Title</label>
                                    </div>
                                    <div className = "menu-input-area">
                                        <div className = "character-input-box field-size-md">
                                            <input className = "form-control character-input" type="text" placeholder="Add here..." autoComplete="off" defaultValue={currTitle} ref = {Title => this.Title = Title}/>
                                        </div>
                                    </div>
                                </div>
                                <div className = "menu-input-block field-size-lg" key = {-1}>
                                    <div className = "menu-label">
                                        <label className = "menu-title">Description</label>
                                    </div>
                                    <div className = "menu-input-area">
                                        <div className = "character-input-box field-size-md">
                                            <input className = "form-control character-input" type="text" placeholder="Add here..." autoComplete="off" defaultValue={currDesc} ref = {Desc => this.Desc = Desc}/>
                                        </div>
                                    </div>
                                </div>
                                <div className = "menu-input-block field-size-lg" key = {0}>
                                    <div className = "menu-label">
                                        <label className = "menu-title">Unit</label>
                                    </div>
                                    <div className = "menu-input-area">
                                        <div className = "character-input-box field-size-md">
                                            <input className = "form-control character-input" type="text" placeholder="Add here..." autoComplete="off" defaultValue={this.state.currentData.Unit || ''} ref = {Unit => this.Unit = Unit}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className = 'menu-footer'>
                            <div className = 'config-input-tabs-buttons'>
                                <Button
                                    className = 'config-input-tabs-button theme-button'
                                    value = {buttonText}
                                    buttonOnClick = {(e) => {
                                        let tempObj = {},
                                            currentTitile = this.Title.value.trim(),
                                            currentDesc = this.Desc.value.trim(),
                                            currentUnit = this.Unit.value.trim();

                                        if(currentTitile === '' || currentUnit === '') {
                                            alert(`The field can't be empty`);
                                            return;
                                        }
                                        if(!this.checkValidName(currentTitile)) {
                                            alert(`This is not a valid title`);
                                            return;
                                        }
                                        this.setState({currentData : {Title : currentTitile, Desc: currentDesc, Unit: currentUnit}, tempkey : new Date().getTime()});
                                        currentTitile = currentTitile.toLocaleUpperCase().replace(/ /g, '_');
                                        tempObj = {
                                            "ELEM_TYPE": "number-field",
                                            "ELEM_DESC": currentDesc && currentDesc !== "" ? currentDesc : "NA",
                                            "VALUE": "",
                                            "UNIT": currentUnit ? currentUnit : ""
                                        }
                                        if(currVal) {
                                            tempObj["UNIT"] = currUnit;
                                            tempObj["VALUE"] = currVal;
                                        }
                                        // this.updateOnLocation(tempObj, currentTitile, this.props.parentArray);
                                        this.state.isGeneric ?
                                            this.props.successGenericDataGet(this.updateOnLocation(tempObj, currentTitile, this.props.parentArray)) :
                                            this.props.updateBotValue(this.updateOnLocation(tempObj, currentTitile, this.props.parentArray));
                                        this.props.updateCurrentSelectedMenu('');
                                        this.setState({currentData: { title: '', Desc: '', Unit: '' }});
                                    }}
                                />
                                <Button
                                    className = 'config-input-tabs-button grey-button'
                                    value = 'Cancel'
                                    buttonOnClick = {(e) => {
                                        this.props.updateCurrentSelectedMenu('');
                                        this.setState({currentData: { title: '', Desc: '' }});
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                );
            
            case 'arrayfield':
                popupHeader = modalType && modalType === 'Clone' ? this.getReadableName('Clone Text Array Field') :
                                           modalType === 'Update' ? this.getReadableName('Update Text Array Field') :
                                           this.getReadableName('Add Text Array Field');
                return(
                    <div className = 'create-menu-box' key = {this.state.tempkey}>
                        <h3 className = 'tab-header'>{popupHeader}</h3>
                        <div className = 'menu-body'>
                            <div className = 'menu-input-wrapper'>
                                <div className = "menu-input-block field-size-lg" key = {-2}>
                                    <div className = "menu-label">
                                        <label className = "menu-title">Title</label>
                                    </div>
                                    <div className = "menu-input-area">
                                        <div className = "character-input-box field-size-md">
                                            <input className = "form-control character-input" type="text" placeholder="Add here..." autoComplete="off" defaultValue={currTitle} ref = {Title => this.Title = Title}/>
                                        </div>
                                    </div>
                                </div>
                                <div className = "menu-input-block field-size-lg" key = {-1}>
                                    <div className = "menu-label">
                                        <label className = "menu-title">Description</label>
                                    </div>
                                    <div className = "menu-input-area">
                                        <div className = "character-input-box field-size-md">
                                            <input className = "form-control character-input" type="text" placeholder="Add here..." autoComplete="off" defaultValue={currDesc} ref = {Desc => this.Desc = Desc}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className = 'menu-footer'>
                            <div className = 'config-input-tabs-buttons'>
                                <Button
                                    className = 'config-input-tabs-button theme-button'
                                    value = {buttonText}
                                    buttonOnClick = {(e) => {
                                        let tempObj = {},
                                            currentTitile = this.Title.value.trim(),
                                            currentDesc = this.Desc.value.trim();

                                        if(currentTitile === '') {
                                            alert(`This field can't be empty`);
                                            return;
                                        }
                                        if(!this.checkValidName(currentTitile)) {
                                            alert(`This is not a valid title`);
                                            return;
                                        }
                                        this.setState({currentData : {Title : currentTitile, Desc: currentDesc}, tempkey : new Date().getTime()});
                                        currentTitile = currentTitile.toLocaleUpperCase().replace(/ /g, '_');
                                        tempObj = {
                                            "ELEM_TYPE": "array-field",
                                            "ELEM_DESC": currentDesc !== "" ? currentDesc : "NA",
                                            "VALUE": [""]
                                        }
                                        if(currVal) {
                                            tempObj["VALUE"] = currVal;
                                        }
                                        // this.updateOnLocation(tempObj, currentTitile, this.props.parentArray);
                                        this.state.isGeneric ?
                                            this.props.successGenericDataGet(this.updateOnLocation(tempObj, currentTitile, this.props.parentArray)) :
                                            this.props.updateBotValue(this.updateOnLocation(tempObj, currentTitile, this.props.parentArray));
                                        this.props.updateCurrentSelectedMenu('');
                                        this.setState({currentData: { title: '', Desc: '' }});
                                    }}
                                />
                                <Button
                                    className = 'config-input-tabs-button grey-button'
                                    value = 'Cancel'
                                    buttonOnClick = {(e) => {
                                        this.props.updateCurrentSelectedMenu('');
                                        this.setState({currentData: { title: '', Desc: '' }});
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                );

            case 'groupfield':
                popupHeader = modalType && modalType === 'Clone' ? this.getReadableName('Clone Group') :
                                           modalType === 'Update' ? this.getReadableName('Update Group') :
                                           this.getReadableName('Add Group');
                return(
                    <div className = 'create-menu-box' key = {this.state.tempkey}>
                        <h3 className = 'tab-header'>{popupHeader}</h3>
                        <div className = 'menu-body'>
                            <div className = 'menu-input-wrapper'>
                                <div className = "menu-input-block field-size-lg" key = {-2}>
                                    <div className = "menu-label">
                                        <label className = "menu-title">Title</label>
                                    </div>
                                    <div className = "menu-input-area">
                                        <div className = "character-input-box field-size-md">
                                            <input className = "form-control character-input" type="text" placeholder="Add here..." autoComplete="off" defaultValue={currTitle} ref = {Title => this.Title = Title}/>
                                        </div>
                                    </div>
                                </div>
                                <div className = "menu-input-block field-size-lg" key = {-1}>
                                    <div className = "menu-label">
                                        <label className = "menu-title">Description</label>
                                    </div>
                                    <div className = "menu-input-area">
                                        <div className = "character-input-box field-size-md">
                                            <input className = "form-control character-input" type="text" placeholder="Add here..." autoComplete="off" defaultValue={currDesc} ref = {Desc => this.Desc = Desc}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className = 'menu-footer'>
                            <div className = 'config-input-tabs-buttons'>
                                <Button
                                    className = 'config-input-tabs-button theme-button'
                                    value = {buttonText}
                                    buttonOnClick = {(e) => {
                                        let tempObj = {},
                                            currentTitile = this.Title.value.trim(),
                                            currentDesc = this.Desc.value.trim();

                                        if(currentTitile === '') {
                                            alert(`This field can't be empty`);
                                            return;
                                        }
                                        if(!this.checkValidName(currentTitile)) {
                                            alert(`This is not a valid title`);
                                            return;
                                        }
                                        this.setState({currentData : {Title : currentTitile, Desc: currentDesc}, tempkey : new Date().getTime()});
                                        currentTitile = currentTitile.toLocaleUpperCase().replace(/ /g, '_');
                                        if(currExtra) {
                                            tempObj = {...currExtra}
                                        }
                                        tempObj = {
                                            "ELEM_TYPE": currentType !== "" ? currentType : "group",
                                            "ELEM_DESC": currentDesc !== "" ? currentDesc : "NA"
                                        }
                                        // this.updateOnLocation(tempObj, currentTitile, this.props.parentArray);
                                        let tempArr = (this.props.parentArray.length - 1)
                                        this.state.isGeneric ?
                                            this.props.successGenericDataGet(this.updateOnLocation(tempObj, currentTitile, this.props.parentArray)) :
                                            this.props.updateBotValue(this.updateOnLocation(tempObj, currentTitile, this.props.parentArray));
                                        this.props.updateCurrentSelectedMenu('');
                                        this.setState({currentData: { title: '', Desc: '' }});
                                    }}
                                />
                                <Button
                                    className = 'config-input-tabs-button grey-button'
                                    value = 'Cancel'
                                    buttonOnClick = {(e) => {
                                        this.props.updateCurrentSelectedMenu('');
                                        this.setState({currentData: { title: '', Desc: '' }});
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                );

            case 'objectGroupfield':
                popupHeader = modalType && modalType === 'Clone' ? this.getReadableName('Clone Group') :
                                           modalType === 'Update' ? this.getReadableName('Update Group') :
                                           this.getReadableName('Add Group');
                return(
                    <div className = 'create-menu-box' key = {this.state.tempkey}>
                        <h3 className = 'tab-header'>{popupHeader}</h3>
                        <div className = 'menu-body'>
                            <div className = 'menu-input-wrapper'>
                                <div className = "menu-input-block field-size-lg" key = {-2}>
                                    <div className = "menu-label">
                                        <label className = "menu-title">Title</label>
                                    </div>
                                    <div className = "menu-input-area">
                                        <div className = "character-input-box field-size-md">
                                            <input className = "form-control character-input" type="text" placeholder="Add here..." autoComplete="off" defaultValue={currTitle} ref = {Title => this.Title = Title}/>
                                        </div>
                                    </div>
                                </div>
                                <div className = "menu-input-block field-size-lg" key = {-1}>
                                    <div className = "menu-label">
                                        <label className = "menu-title">Description</label>
                                    </div>
                                    <div className = "menu-input-area">
                                        <div className = "character-input-box field-size-md">
                                            <input className = "form-control character-input" type="text" placeholder="Add here..." autoComplete="off" defaultValue={currDesc} ref = {Desc => this.Desc = Desc}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className = 'menu-footer'>
                            <div className = 'config-input-tabs-buttons'>
                                <Button
                                    className = 'config-input-tabs-button theme-button'
                                    value = {buttonText}
                                    buttonOnClick = {(e) => {
                                        let tempObj = {},
                                            currentTitile = this.Title.value.trim(),
                                            currentDesc = this.Desc.value.trim();

                                        if(currentTitile === '') {
                                            alert(`This field can't be empty`);
                                            return;
                                        }
                                        if(!this.checkValidName(currentTitile)) {
                                            alert(`This is not a valid title`);
                                            return;
                                        }
                                        this.setState({currentData : {Title : currentTitile, Desc: currentDesc}, tempkey : new Date().getTime()});
                                        currentTitile = currentTitile.toLocaleUpperCase().replace(/ /g, '_');
                                        tempObj = {
                                            "ELEM_TYPE": "object-group",
                                            "ELEM_DESC": currentDesc !== "" ? currentDesc : "NA",
                                            "VALUE": [{}]
                                        }

                                        if(currVal) {
                                            tempObj["VALUE"] = currVal;
                                        }
                                        // this.updateOnLocation(tempObj, currentTitile, this.props.parentArray);
                                        this.state.isGeneric ?
                                            this.props.successGenericDataGet(this.updateOnLocation(tempObj, currentTitile, this.props.parentArray)) :
                                            this.props.updateBotValue(this.updateOnLocation(tempObj, currentTitile, this.props.parentArray));
                                        this.props.updateCurrentSelectedMenu('');
                                        this.setState({currentData: { title: '', Desc: '' }});
                                    }}
                                />
                                <Button
                                    className = 'config-input-tabs-button grey-button'
                                    value = 'Cancel'
                                    buttonOnClick = {(e) => {
                                        this.props.updateCurrentSelectedMenu('');
                                        this.setState({currentData: { title: '', Desc: '' }});
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                );

            default:
                // console.log('this type is not handled', type);
                return null;
        }
    }

    render() {
        if(this.props.selectedMenuType === '') {
            return null;
        }
        // console.log(this.props.parentArray, this.props.selectedMenuType, this.state.isGeneric, this.props)
        return (
            <div className = 'create-menu-inner-wrapper' onClick = {(e) => {e.stopPropagation();}}>
                {this.addMenuType(this.props.selectedMenuType)}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        tabListArray: state.UiReducer && state.UiReducer.tabListArray && state.UiReducer.tabListArray.length ? state.UiReducer.tabListArray : [],
        selectedBotData: state.UiReducer && state.UiReducer.selectedBotData ? state.UiReducer.selectedBotData : false,
        editableBotData: state.UiReducer && state.UiReducer.editableBotData ? state.UiReducer.editableBotData : {},
        genericBotData: state.UiReducer && state.UiReducer.genericBotData ? state.UiReducer.genericBotData : {},
        currentActiveTab: state.UiReducer && state.UiReducer.currentActiveTab ? state.UiReducer.currentActiveTab : 'chatbot',
        availableBotList: state.UiReducer && state.UiReducer.availableBotList ? state.UiReducer.availableBotList : [],
        highlightSearchedData: state.UiReducer && state.UiReducer.highlightSearchedData ? state.UiReducer.highlightSearchedData : {},
        currentLanguage: state.UiReducer && state.UiReducer.currentLanguage ? state.UiReducer.currentLanguage : 'en'
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        updateCurrentTabStatus,
        updateBotValue,
        successGenericDataGet
    },
        dispatch
    );
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(CreateModal));
